/**
 * Gets the current geolocation position.
 * @returns {Promise<GeolocationPosition | null>} The position or null if unavailable.
 */
export async function getLocation(): Promise<GeolocationPosition | null> {
  try {
    const position = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        maximumAge: Infinity,
      });
    });
    return position;
  } catch {
    return null;
  }
}
